var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","background-color":"rgba(29,66,129,0.77)","color":"white"}},[_c('v-divider'),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(" "+_vm._s(_vm.titel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }